/* eslint-disable import/order */
import React from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, ScrollRestoration, createBrowserRouter } from 'react-router-dom'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import reportWebVitals from './reportWebVitals'
import { browserTracingIntegration, init as sentryInit } from '@sentry/react'
import { App } from './app'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-datepicker/dist/react-datepicker.css'
import './asset/scss/global.scss'
import 'react-toastify/dist/ReactToastify.css'
import './index.scss'
import './styles/globals.css'
import './styles/tailwind-isolation.css'
import './styles/auth.scss'
import { config } from './util/config'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './query-client'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { routes } from './screen/router'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { authConfig } from './util/auth-config'
/* eslint-enable import/order */

if (config.sentry)
  sentryInit({
    environment: window.location.host,
    dsn: config.sentry.dsn,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: config.sentry.sampleRate,
  })

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: (
        <>
          <ScrollRestoration />
          <App />
        </>
      ),
      children: routes,
    },
  ],
  {
    basename: import.meta.env.BASE_URL,
  },
)

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId={authConfig.google.clientId}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <RouterProvider router={router} />
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </React.StrictMode>,
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
